module.exports = function(bootstrap) {
    bootstrap.run(["Service", "services", function (Service, services) {
        new Service({
            name: 'tobaccoRetrieve',
            group: "rbsmbl",
            url: "/rbsmbl/x-services/tobacco/individualinfo",
            contentType: 'application/json',
            getTobaccoInfo: function(clientNumber,groupNumber) {
                var  originalUrl  = '/rbsmbl/x-services/tobacco/individualinfo?clientId=clientNumber&groupId=groupNumber';
                this.url = originalUrl.replace('clientNumber', clientNumber).replace('groupNumber',groupNumber);
                return this.get();
            },
            getTobaccoFamilyInfo: function(clientNumber,groupNumber) {
                var  originalUrl = '/rbsmbl/x-services/tobacco/familyinfo?clientId=clientNumber&groupId=groupNumber';
                this.url = originalUrl.replace('clientNumber',clientNumber).replace('groupNumber',groupNumber);
                return this.get();
            }
        });
    }]);
};


